/**
 * AGENT VIEW PAGE
 *
 * Main page component that displays the AgentView.
 * This is the default view when users are logged in.
 */

import { useEffect } from "react";
import { useUIStore } from "@/stores/uiStore";
import { useWorldStore } from "@/stores/worldStore";
import { useWorkspaceStore } from "@/stores/workspaceStore";
import { AgentsPage } from "@/features/review/AgentsPage";

export default function AgentViewPage() {
  const { theme } = useUIStore();
  const { fetchWorldData } = useWorldStore();
  const { ensureWorkspaceReady } = useWorkspaceStore();

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  useEffect(() => {
    (async () => {
      await ensureWorkspaceReady();
      await fetchWorldData();
    })().catch((err) => console.error("[AgentViewPage] workspace init failed:", err));
  }, [ensureWorkspaceReady, fetchWorldData]);

  return (
    <div className="w-full h-full flex flex-col overflow-hidden" data-testid="container-agent-view-page">
      <AgentsPage />
    </div>
  );
}
